<template>
     <div class="clock" :id='cId'>
        <div class="num h10">
            <div class="upper"></div>
            <div class="base upper"></div>
            <div class="base lower"></div>
            <div class="lower"></div>
        </div>
        
        <div class="num h0">
            <div class="upper"></div>
            <div class="base upper"></div>
            <div class="base lower"></div>
            <div class="lower"></div>
        </div>
        
        <div class="colon">:</div>
        
        <div  class="num m10">
            <div class="upper"></div>
            <div class="base upper"></div>
            <div class="base lower"></div>
            <div class="lower"></div>
        </div>
        
        <div  class="num m0">
            <div class="upper"></div>
            <div class="base upper"></div>
            <div class="base lower"></div>
            <div class="lower"></div>
        </div>
        
        <div class="colon">:</div>
        
        <div class="num s10">
            <div class="upper"></div>
            <div class="base upper"></div>
            <div class="base lower"></div>
            <div class="lower"></div>
        </div>
        
        <div  class="num s0">
            <div class="upper"></div>
            <div class="base upper"></div>
            <div class="base lower"></div>
            <div class="lower"></div>
        </div>
    </div>
</template>
<script>
import TweenMax from './js/TweenMax.min.js'
export default {
    name:'clock',
    props:{
        shenyu:{
            type:Number,
            default:0
        },
        hour:String,
        cId:String
    },
    data(){
        return{
            ss:'',
            mm:'',
            hh:'',
            interval:'',
            time:this.shenyu
        }
    },
    methods:{
        initClock(id){
            TweenMax.set('#'+id+".clock", {perspective:1500});
            TweenMax.set('#'+id+" .upper", {rotationX:0.01, transformOrigin:"50% 100%"});
            TweenMax.set('#'+id+" .lower", {rotationX:0.01, transformOrigin:"50% 0%"});
            this.setTimeVars();
            document.querySelectorAll('#'+id+' .h10')[0].childNodes[1].innerHTML = document.querySelectorAll('#'+id+' .h10')[0].childNodes[3].innerHTML = "<span>"+Number(this.hh.substr(0,1))+"</span>";
            document.querySelectorAll('#'+id+' .h0')[0].childNodes[1].innerHTML = document.querySelectorAll('#'+id+' .h0')[0].childNodes[3].innerHTML = "<span>"+Number(String(this.hh).substr(1,1))+"</span>";
            document.querySelectorAll('#'+id+' .m10')[0].childNodes[1].innerHTML = document.querySelectorAll('#'+id+' .m10')[0].childNodes[3].innerHTML = "<span>"+Number(this.mm.substr(0,1))+"</span>";
            document.querySelectorAll('#'+id+' .m0')[0].childNodes[1].innerHTML = document.querySelectorAll('#'+id+' .m0')[0].childNodes[3].innerHTML = "<span>"+Number(this.mm.substr(1,1))+"</span>";
            document.querySelectorAll('#'+id+' .s10')[0].childNodes[1].innerHTML = document.querySelectorAll('#'+id+' .s10')[0].childNodes[3].innerHTML = "<span>"+Number(this.ss.substr(0,1))+"</span>";
            document.querySelectorAll('#'+id+' .s0')[0].childNodes[1].innerHTML = document.querySelectorAll('#'+id+' .s0')[0].childNodes[3].innerHTML = "<span>"+Number(this.ss.substr(1,1))+"</span>";
            let _this=this;
            this.interval = setInterval(function(){
                _this.setTimeVars();
                _this.tick('#'+id+' .s0', Number(_this.ss.substr(1,1)) )
                if (_this.ss.substr(1,1)=="9"){//秒数个位数到9开始改十位数
                    _this.tick('#'+id+' .s10', Number(_this.ss.substr(0,1)) ) 
                    if(_this.ss.substr(0,1)=="5"){
                    _this.tick('#'+id+' .s10', 5, true)
                    _this.tick('#'+id+' .m0', Number(_this.mm.substr(1,1)))
                    if(_this.mm.substr(1,1)=="9"){//分数个位数到9开始改十位数
                        _this.tick('#'+id+' .m10', Number(_this.mm.substr(0,1)) ) 
                        if(_this.mm.substr(0,1)=="5"){
                        _this.tick('#'+id+' .m10', 5, true)
                        _this.tick('#'+id+' .h0', Number(_this.hh.substr(1,1)))
                        if(_this.hh.substr(1,1)=="9"){
                            _this.tick('#'+id+' .h10', Number(_this.hh.substr(0,1)))
                            if(_this.hh.substr(0,1)=='0'){
                            _this.tick('#'+id+' .h10', 0,true)
                            }
                        }
                        }
                    }
                    }
                }
            }, 1000) 
        },
        setTimeVars(){
            if(!this.time){
            }else{
                this.time = this.time - 1000;
            }
            if(this.time<=1000){//倒计时结束
                this.ss='00';
                this.hh='00';
                this.mm='00';
                clearInterval(this.interval);
                this.interval==null;
            }else{
                var shengyuD=parseInt(this.time/(60*60*24*1000));//转换为天
                var D=parseInt(this.time)-parseInt(shengyuD*60*60*24*1000);//除去天的毫秒数
                var shengyuH=parseInt(D/(60*60*1000));//除去天的毫秒数转换成小时
                var H=D-shengyuH*60*60*1000;//除去天、小时的毫秒数
                var shengyuM=parseInt(H/(60*1000));//除去天的毫秒数转换成分钟
                var M=H-shengyuM*60*1000;//除去天、小时、分的毫秒数
                var S=parseInt((this.time-shengyuD*60*60*24*1000-shengyuH*60*60*1000-shengyuM*60*1000)/1000);//除去天、小时、分的毫秒数转化为秒
                this.ss = String(S);
                this.mm = String(shengyuM);
                this.hh = String(shengyuH);
            }
            if (this.ss.length==1) this.ss = "0"+this.ss;
            if (this.mm.length==1) this.mm = "0"+this.mm;
            if (this.hh.length==1) this.hh = "0"+this.hh;
        },
        tick(mc,i, toZero){
            if(this.time<=0){
                return
            }
            document.querySelectorAll(mc)[0].childNodes[0].innerHTML = "<span>"+i+"</span>"; //end upper
            document.querySelectorAll(mc)[0].childNodes[3].innerHTML = "<span>"+i+"</span>"; //end lower
            if ( i==9 || toZero ){
                document.querySelectorAll(mc)[0].childNodes[1].innerHTML = "<span>0</span>"; //start upper
                document.querySelectorAll(mc)[0].childNodes[2].innerHTML = "<span>0</span>"; //start lower
            }else{
                document.querySelectorAll(mc)[0].childNodes[1].innerHTML = "<span>"+(i+1)+"</span>"; //start upper
                document.querySelectorAll(mc)[0].childNodes[2].innerHTML = "<span>"+(i+1)+"</span>"; //start lower
            }
            TweenMax.fromTo(document.querySelectorAll(mc)[0].childNodes[0], .3, {alpha:0},{alpha:1, ease:Power4.easeIn})  
            //TweenMax.fromTo(mc.childNodes[1], .3, {rotationX:0, background:"linear-gradient(0deg, rgba(200,200,200,1), rgba(255,255,255,1) 15%)"},{rotationX:-90, ease:Power1.easeIn})
            TweenMax.fromTo(document.querySelectorAll(mc)[0].childNodes[1], .3, {rotationX:0, background:"rgba(00,00,00,0.2)"},{rotationX:-90, ease:Power1.easeIn})
            TweenMax.fromTo(document.querySelectorAll(mc)[0].childNodes[3], .5+.2*Math.random(), {rotationX:90},{rotationX:0, ease:Bounce.easeOut, delay:.3})
            TweenMax.fromTo(document.querySelectorAll(mc)[0].childNodes[2], .6, {alpha:1},{alpha:0, ease:Bounce.easeOut, delay:.3})
        }
    },
    mounted(){
        this.time=this.shenyu;
        this.initClock(this.cId);
    },
    beforeDestroy(){
        clearInterval(this.interval);
        this.interval==null;
    }
}
</script>
<style scoped>
    @import './css/dateDemo.css';
</style>